<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zMlAbZ/tc-custom/9780830863983.jpg?1696025269067" alt="This image is the cover for the book The Messiah, LifeGuide Bible Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Messiah, LifeGuide Bible Studies
      </h1>
      <p class="bookDescription body article font2">
        <p>Prophets prophesied about him. Angels and shepherds rejoiced at his birth. Friends cried for joy at his resurrection. And we still celebrate him today. He is Jesus, the Messiah. Perfect for Advent or Lent, this eight-session LifeGuide® Bible Study guide explores some of the key passages in the Old Testament about the Messiah and their completion in the life and saving work of Jesus. These passages have had a profound effect on the imagination and worship of Christians for two thousand years, leading George Frederic Handel to write one of the greatest expressions of worship and adoration—his oratorio, the <em>Messiah.</em> We hear parts of it sung every year during the Christmas season, but what many listeners fail to realize is that the entire text of Handel's<em>Messiah</em> is drawn from Scripture—and many of the Old Testament passages that shaped Israel's hope for their Redeemer are included in that text. This guide leads you through Scripture passages used in Handel's work that highlight who Jesus is and what he came to do. It might change the way you listen to the <em>Messiah.</em> Even more, it might change the way you live. For over three decades LifeGuide Bible Studies have provided solid biblical content and raised thought-provoking questions—making for a one-of-a-kind Bible study experience for individuals and groups. This series has more than 130 titles on Old and New Testament books, character studies, and topical studies.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Douglas Connelly
      </h2>
      
      <p class="authorDescription body article"><p>Douglas Connelly (MDiv and MTh, Grace Theological Seminary) is senior pastor at Davison Missionary Church near Flint, Michigan, after serving twelve years as senior pastor at Parkside Community Church in Sterling Heights, Michigan. A writer and speaker, he has written seventeen LifeGuide Bible Studies as well as several books, including <em>The Bible for Blockheads</em> and <em>Angels Around Us.</em> He and his wife Karen have three adult children and six grandchildren.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ff6e08e8